// removed by extract-text-webpack-plugin
module.exports = {"modal-title":"app-pages-Library-Item-ItemDetail-ItemForm-CreateCategoryModal-__CreateCategoryModal___38eUI","modal-container":"app-pages-Library-Item-ItemDetail-ItemForm-CreateCategoryModal-__CreateCategoryModal___1y6d9"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Item/ItemDetail/ItemForm/CreateCategoryModal/CreateCategoryModal.css
// module id = 2422
// module chunks = 0